import { createRoot } from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";

import App from "./App";
import Generator from "./components/Generator";
import Chat from "./components/Chat";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { generators, chats } from "./generators";
import SignupPage from "./components/accounts/SignupPage";
import SigninPage from "./components/accounts/SigninPage";
import ChatLibrary from "./components/ChatLibrary";
import { AccountProvider } from "./lib/accountContext";
import BillingPortalRedirect from "./components/accounts/BillingPortalRedirect";
import SubscribeRedirect from "./components/accounts/SubscribeRedirect";
import { Analytics } from "@vercel/analytics/react";
import PDFChat from "./components/ChatLibrary/PDFChat";
import PageNotFound from "./components/PageNotFound";
import { app } from "./firebase";
import axios from "axios";

import "./index.css";

// Switch between local and production API
axios.defaults.baseURL = "https://api.wordbase.ai";


const root = createRoot(document.getElementById("root")); // createRoot(container!) if you use TypeScript
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/signup",
    element: <SignupPage />,
  },
  {
    path: "/signin",
    element: <SigninPage />,
  },
  {
    path: "/open-billing",
    element: <BillingPortalRedirect />,
  },
  {
    path: "/open-checkout",
    element: <SubscribeRedirect />,
  },
  {
    path: "/chats",
    element: <ChatLibrary />,
  },
  {
    path: "/chats/*",
    element: <PDFChat />
  },
  ...generators.map((generator) => ({
    path: generator.path,
    element: <Generator generatorData={generator} />,
  })),
  ...chats.map((generator) => ({
    path: generator.path,
    element: <Chat generatorData={generator} />,
  })),
  {
    path: "*",
    element: <PageNotFound />,
  }
]);

root.render(
  <ChakraProvider>
    <AccountProvider>
      <RouterProvider router={router} />
      <Analytics />
    </AccountProvider>
  </ChakraProvider>
);

// document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
